// FILE: readFileAsDataUrl.ts
// Purpose: Read a picked File into a data URL, for the avatar upload endpoints that want one.
// Exports: `readFileAsDataUrl`.

/**
 * `FileReader` rather than `file.arrayBuffer()` plus a manual base64 pass:
 * the avatar endpoints want a data URL, and this is the browser API that
 * produces one without the caller having to spell out the header or chunk the
 * encoding.
 *
 * Shared by `ProfileSection` (the signed-in user's own photo) and
 * `UsersSection`'s admin dialog (someone else's photo) — same file, same
 * upload shape, no reason for either to carry its own copy.
 */
export const readFileAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("error", () => reject(new Error("Could not read that file.")));
    reader.addEventListener("load", () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("Could not read that file."));
        return;
      }
      resolve(result);
    });
    reader.readAsDataURL(file);
  });
